import React from 'react';

function DeleteProductDetailTabType({ TabTypeData }) {
  return (
    <div className="text-center">
      <p>
        Are you sure you want to delete tab type <strong>{TabTypeData?.DefaultTitle || TabTypeData?.TabKey}</strong>?
      </p>
      <p className="text-muted small mb-0">
        Deletion is blocked if any product detail tab references this tab key.
      </p>
    </div>
  );
}

export default DeleteProductDetailTabType;
